// Result Verification (analyst review workflow). Mirrors backend
// api.core/Authorization/ActionKeys.cs — keep literals in sync.
export const ACTIONS_RESULT_VERIFICATION = {
	RESULT_VERIFICATION: 'result_verification',
	RESULT_VERIFICATION_VIEW: 'result_verification_view',
	RESULT_VERIFICATION_VERDICT: 'result_verification_verdict',
	RESULT_VERIFICATION_COMMENT: 'result_verification_comment',
	RESULT_VERIFICATION_FLAG: 'result_verification_flag',
	RESULT_VERIFICATION_TAG: 'result_verification_tag',
	/** One-click acceptance of the system-suggested review (flags + tags + verdict). */
	RESULT_VERIFICATION_ACCEPT_REVIEW: 'result_verification_accept_review',
	/**
	 * Managing the flag catalogue itself (Core `/api/v1/ResultFlag` writes) — distinct from
	 * applying a flag to a result.
	 */
	RESULT_VERIFICATION_FLAG_VOCABULARY: 'result_verification_flag_vocabulary',
	/** Adjudicating a flag: resolve, and overturn a resolution. */
	RESULT_VERIFICATION_FLAG_RESOLVE: 'result_verification_flag_resolve',
} as const;
